import React from 'react';
import { useHistory } from 'react-router-dom';
import { Text } from '../atom/Text';

import { Flex } from '../atom/Layout';
import { Button } from '../atom/Button';
import { VerticalPadding } from '../atom/Padding';

import { ReactComponent as Logo } from '../../../lib/image/icons/logo/LOGO02.svg';

export const EmptyMessage = ({
  messageList = [''],
  buttonPath = '/',
  buttonTitle = '홈으로',
  buttonClickEvent = undefined,
}) => {
  const history = useHistory();

  return (
    <Flex column padding="1.875rem 0" width="100%">
      <Logo style={{ width: '8rem', height: '7.785rem' }} />
      <VerticalPadding padding={48}>
        {messageList.map((message, idx) => (
          <Text
            size={14}
            key={idx}
            style={{ display: 'block' }}
            textAlign="center"
            lineHeight="1.25rem"
          >
            {message}
          </Text>
        ))}
      </VerticalPadding>
      <Button
        color="orangePink"
        onClick={
          buttonClickEvent ? buttonClickEvent : () => history.push(buttonPath)
        }
        style={{ width: '50%' }}
      >
        {buttonTitle}
      </Button>
    </Flex>
  );
};
